import { fetchServices } from '../../redux/slices/servicesSlice';
import { fetchDayOffs } from '../../redux/slices/dayOffSlice';
import { fetchMasterBreaks } from '../../redux/slices/masterBreakSlice';
import { fetchBusinessHours } from '../../redux/slices/businessHoursSlice';

export const loadMasterScheduleData = async (masterId, dispatch) => {
    const promises = [
        dispatch(fetchServices(masterId)),
        dispatch(fetchBusinessHours(masterId)),
        dispatch(fetchDayOffs(masterId)),
        dispatch(fetchMasterBreaks(masterId)),
    ];

    await Promise.all(promises);
};
